import AdminHeaderBar from './AdminHeaderBar';

export default AdminHeaderBar;
